import { jsPDF } from "jspdf";
import logoPng from "@/assets/brema-logo.png";

const DARK = [19, 24, 34];
const GRAY = [110, 116, 128];
const BORD = [150, 30, 55]; // bordeaux Brema
const HAIR = [225, 226, 230];

const slugify = (s) =>
  (s || "brema").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 48) || "comunicato";

// Genera il PDF ufficiale "Brema Media Release" con logo in testata, categoria/data,
// titolo, testo integrale (tradotto) e blocco contatti PR in calce.
export function generateReleasePdf({ title, category, date, body, contacts = {}, labels = {} }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 56;
  let y = 50;

  // Logo ufficiale (mantiene le proporzioni originali per non risultare schiacciato)
  let logoW = 44, logoH = 15;
  try {
    const props = doc.getImageProperties(logoPng);
    if (props && props.width && props.height) {
      logoH = (props.height / props.width) * logoW;
    }
    doc.addImage(logoPng, "PNG", M, y, logoW, logoH);
  } catch (e) { logoH = 32; }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...GRAY);
  doc.text(String(labels.release_detail_title || "PRESS RELEASE").toUpperCase(), W - M, y + logoH / 2 + 3, { align: "right" });
  y += logoH + 26;

  doc.setDrawColor(...BORD);
  doc.setLineWidth(1.4);
  doc.line(M, y, W - M, y);
  y += 26;

  const meta = [category, date].filter(Boolean).join("     ·     ");
  if (meta) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(...BORD);
    doc.text(meta.toUpperCase(), M, y);
    y += 22;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(...DARK);
  const titleLines = doc.splitTextToSize(title || "", W - 2 * M);
  doc.text(titleLines, M, y);
  y += titleLines.length * 24 + 16;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...DARK);
  const paras = Array.isArray(body) ? body : String(body || "").split(/\n\s*\n/);
  const lineH = 16;
  for (const p of paras) {
    if (!String(p || "").trim()) continue;
    const lines = doc.splitTextToSize(String(p), W - 2 * M);
    for (const ln of lines) {
      if (y > H - 130) { doc.addPage(); y = 56; }
      doc.text(ln, M, y);
      y += lineH;
    }
    y += 9;
  }

  // Blocco contatti PR
  const contactLines = ["office", "contact", "email", "phone", "website", "other"]
    .map((k) => (contacts[k] || "").trim())
    .filter(Boolean);
  const needed = 40 + contactLines.length * 14;
  if (y > H - needed) { doc.addPage(); y = 56; }
  y += 12;
  doc.setDrawColor(...HAIR);
  doc.setLineWidth(0.8);
  doc.line(M, y, W - M, y);
  y += 18;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...BORD);
  doc.text(String(labels.press_contacts || "Press contacts").toUpperCase(), M, y);
  y += 16;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...DARK);
  contactLines.forEach((ln, i) => {
    if (i === 0) doc.setFont("helvetica", "bold");
    else doc.setFont("helvetica", "normal");
    doc.text(ln, M, y);
    y += 14;
  });

  doc.save(`comunicato-${slugify(title)}.pdf`);
}
